module.exports = __webpack_public_path__ + "img/beer_id-53.959d1383.png";